module.exports = __webpack_public_path__ + "static/ipad7.8f6b2a2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/simitri/ipad7.png
// module id = 547
// module chunks = 35783957827783